/* eslint-disable */
if (!Array.from) {
    Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function (value) {
            var number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike /*, mapFn, thisArg */ ) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError("Array.from requires an array-like object - not null or undefined");
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}

var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }

        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else {
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        }
    },

    dataBrowser: [{
            string: navigator.userAgent,
            subString: "Edge",
            identity: "MS Edge"
        },
        {
            string: navigator.userAgent,
            subString: "MSIE",
            identity: "Explorer"
        },
        {
            string: navigator.userAgent,
            subString: "Trident",
            identity: "Explorer"
        },
        {
            string: navigator.userAgent,
            subString: "Firefox",
            identity: "Firefox"
        },
        {
            string: navigator.userAgent,
            subString: "Opera",
            identity: "Opera"
        },
        {
            string: navigator.userAgent,
            subString: "OPR",
            identity: "Opera"
        },

        {
            string: navigator.userAgent,
            subString: "Chrome",
            identity: "Chrome"
        },
        {
            string: navigator.userAgent,
            subString: "Safari",
            identity: "Safari"
        }
    ]
};

BrowserDetect.init();

class Helpers {
    toggleLoading() {
        const body = document.querySelector('body');
        if (body.classList.contains('loading')) {
            body.classList.remove('loading');
        } else {
            body.classList.add('loading');
        }
    }

    isMobile() {
        return document.querySelector('body').classList.contains('mobile') || window.innerWidth <= 960;
    }

    validateFields(fields = []) {
        let isValid = true;
        Array.from(fields).forEach((el) => {
            const val = el.value;

            if (el.classList.contains('email') || el.getAttribute('type') === 'email') {
                if ((val.trim().length && !this.validateEmail(val)) || (el.classList.contains('required') && !this.validateEmail(val))) {
                    isValid = false;
                    const msg = dynamic.translations.invalid_email;
                    this.appendErrorMessage(el, msg);
                    el.classList.add('error');
                }
            } else if (el.classList.contains('required')) {
                if (this.isBlank(val)) {
                    isValid = false;
                    const msg = dynamic.translations.required_field;
                    this.appendErrorMessage(el, msg);
                    el.classList.add('error');
                }
            }

            if (el.classList.contains('required') && (el.classList.contains('checkbox') || el.getAttribute('type') === 'checkbox')) {
                if (!el.checked) {
                    isValid = false;
                    el.classList.add('error');
                }
            }

            if (el.classList.contains('length')) {
                const length = el.getAttribute('data-length');
                if (this.isBlank(val) || val.length < length) {
                    isValid = false;
                    el.classList.add('error');
                }
            }
        });

        return isValid;
    }

    setValueByFieldName(fields = [], name, val = '') {
        fields.each((el) => {
            if (el.getAttribute('name') === name) {
                el.value = val;
            }
        });
    }

    isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    findClosest(el, cls) {
        let elem = null;
        while ((elem = el.parentElement) && !elem.classList.contains(cls));
        return elem;
    }

    appendErrorMessage(el, msg) {
        const parent = this.findClosest(el, 'form-control');
        const feedback = parent.querySelector('.feedback');

        if (feedback) {
            feedback.innerHTML = msg;
            return;
        }
        const span = document.createElement('span');
        span.className = 'feedback';
        span.innerHTML = msg;
        parent.appendChild(span);
    }

    ajaxRequest(url, formData, method, callback, progressCallback) {
        let m = 'post';
        if (method) {
            m = method;
        }

        const req = new XMLHttpRequest();
        try {
            req.onreadystatechange = function () {
                const obj = {
                    success: false,
                    message: ''
                };

                if (req.readyState === 4 && req.status === 200) {
                    obj.success = req.response.success;
                    obj.message = req.response;
                    callback(obj);
                } else if (req.readyState === 4) {
                    obj.success = false;
                    callback(obj);
                }
            };

            if (progressCallback) {
                req.onprogress = progressCallback;
            }

            req.open(m, url);
            req.responseType = 'json';
            req.send(formData);
        } catch (e) {
            const obj = {
                success: false,
                message: e
            };

            callback(obj);
        }
    }

    checkVisible(elm, threshold, mode) {
        threshold = threshold || 0;
        mode = mode || 'visible';

        const rect = elm.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        const above = rect.bottom - threshold < 0;
        const below = rect.top - viewHeight + threshold >= 0;

        return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
    }
}

window.MathUtils = {
    lineEq: (y2, y1, x2, x1, currentVal) => {
        const m = (y2 - y1) / (x2 - x1);
        const b = y1 - m * x1;
        return m * currentVal + b;
    },
    lerp: (a, b, n) => (1 - n) * a + n * b,
    distance: (x1, x2, y1, y2) => {
        const a = x1 - x2;
        const b = y1 - y2;
        return Math.hypot(a, b);
    },
    randomNumber: (min, max) => Math.floor(Math.random() * (max - min + 1) + min)
};
/* eslint-enable */
